var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPen = function SvgPen(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M13.358 2.85a2.477 2.477 0 1 1 3.492 3.496l-6.496 5.656-.323-.323-2.007-2.007-.326-.326zm-6.372 7.205.326.326 2.007 2.007.326.326-.602 2.615a1.5 1.5 0 0 1-1.06 1.11L2.412 18l2.99-2.991a1 1 0 0 0 1.265-.969 1.002 1.002 0 1 0-1.973.26L1.7 17.288l1.561-5.568a1.5 1.5 0 0 1 1.11-1.06l2.615-.602z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPen);
export default ForwardRef;